// extracted by mini-css-extract-plugin
export var buttonContainer = "_8e-1";
export var fontSizeSelect = "_8e-3";
export var formatSelect = "_8e-2";
export var formats = "_8e-4";
export var hidden = "_8e-5";
export var icon = "_8e-6";
export var select = "_8e-0";